var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 6.375C22.625 9.20755 20.2895 11.5 17.5 11.5C14.6617 11.5 12.375 9.21334 12.375 6.375C12.375 3.58554 14.6675 1.25 17.5 1.25C20.2837 1.25 22.625 3.59135 22.625 6.375ZM21.2188 15.25H21.6562C24.604 15.25 27 17.646 27 20.5938V22.125C27 23.0358 26.2582 23.75 25.375 23.75H9.625C8.70072 23.75 8 23.0493 8 22.125V20.5938C8 17.6347 10.3526 15.25 13.2891 15.25H13.7266C14.0716 15.25 14.4888 15.3917 15.1884 15.6329C15.8078 15.8464 16.6258 16.125 17.5 16.125C18.3416 16.125 19.1143 15.8493 19.6999 15.6403L19.7305 15.6294C20.3859 15.3956 20.8157 15.25 21.2188 15.25Z",
    stroke: "#5E6E82",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 7.5C8.25 9.04691 7.00751 10.25 5.5 10.25C3.94546 10.25 2.75 9.05454 2.75 7.5C2.75 5.99249 3.95309 4.75 5.5 4.75C6.99985 4.75 8.25 6.00015 8.25 7.5ZM32.75 7.5C32.75 9.04691 31.5075 10.25 30 10.25C28.4455 10.25 27.25 9.05454 27.25 7.5C27.25 5.99249 28.4531 4.75 30 4.75C31.4998 4.75 32.75 6.00015 32.75 7.5Z",
    stroke: "#5E6E82",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13.75H31.5C32.9998 13.75 34.25 15.0002 34.25 16.5V18.25C34.25 18.805 33.7808 19.25 33.25 19.25H30.264C29.7907 17.1206 28.5783 15.2692 26.8498 14.0125C27.2078 13.8461 27.5961 13.75 28 13.75ZM7 13.75C7.37187 13.75 7.74551 13.8448 8.09771 14.0109C6.368 15.2677 5.15478 17.1197 4.68135 19.25H1.75C1.17984 19.25 0.75 18.8202 0.75 18.25V16.5C0.75 14.9925 1.95309 13.75 3.5 13.75H7Z",
    stroke: "#5E6E82",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.adb0cfab51cac47f267f40a61dc2130d.svg";
export { ForwardRef as ReactComponent };